export class RoadmapConflictError extends Error {
    constructor (err) {
        super(err);
        this.name = 'RoadmapConflictError';
    }
}

export class RoadmapForbiddenInteractionError extends Error {
    constructor (err) {
        super(err);
        this.name = 'RoadmapForbiddenInteractionError';
    }
}

export class RoadmapOutOfBoundsInteractionError extends Error {
    constructor (err) {
        super(err);
        this.name = 'RoadmapOutOfBoundsInteractionError';
    }
}

export class RoadmapQueueNotClearedError extends Error {
    constructor (err) {
        super(err);
        this.name = 'RoadmapQueueNotClearedError';
    }
}
